import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import styles from "./title.module.css"

@tagName("")
export default class DayMenuSecondaryTitle extends Component {
  readonly styles = styles
}
